import { gql } from "@apollo/client";

const GET_PERMISSIONS = gql`
  query permissions {
    permissions {
      available {
        readPermissions
        writePermissions
      }
      availableForCurrentUser {
        readPermissions
        writePermissions
      }
    }
  }
`;

export default GET_PERMISSIONS;
